var _circle, _path, _g, _circle2, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvalid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9,
    cy: 32.4005,
    r: 5.4,
    fill: "#D28F7F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_814_25228",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 45,
    width: 25,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6997 51.9912C27.9839 47.8296 32.3687 45.0018 37.3979 45.0018C42.4325 45.0018 46.8173 47.8296 49.0997 51.993L45.5717 54C43.9643 51.084 40.9133 49.1166 37.3979 49.1166C33.8843 49.1166 30.8369 51.084 29.2295 54L25.6997 51.9912Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_814_25228)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6997 36.002H58.0997V63.002H16.6997V36.002Z",
    fill: "#D28F7F"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.9,
    cy: 32.4005,
    r: 5.4,
    fill: "#D28F7F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_814_25228",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 73,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0.000488281H72.4998V71.9998H0.5V0.000488281Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_814_25228)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 65.1191C20.417 65.1191 7.3814 52.0817 7.3814 36.0005C7.3814 19.9175 20.417 6.88009 36.5 6.88009C52.583 6.88009 65.6186 19.9175 65.6186 36.0005C65.6186 52.0817 52.583 65.1191 36.5 65.1191ZM36.5 0.000488281C16.6172 0.000488281 0.5 16.1177 0.5 36.0005C0.5 55.8815 16.6172 72.0005 36.5 72.0005C56.3828 72.0005 72.5 55.8815 72.5 36.0005C72.5 16.1177 56.3828 0.000488281 36.5 0.000488281Z",
    fill: "#D28F7F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalid);
export default __webpack_public_path__ + "static/media/invalid.8fe12d3b2f2df97ab1cc829f12c782f3.svg";
export { ForwardRef as ReactComponent };